// SQLite CURRENT_TIMESTAMP values are UTC strings without a zone marker
// ("YYYY-MM-DD HH:MM:SS"). The browser parses those as local time, so every
// raw display was off by the UTC offset. Parse as UTC, render as local.

export function parseUtc(value) {
  if (!value) return null
  const s = String(value).trim()
  const iso = s.includes('T') ? s : s.replace(' ', 'T')
  const withZone = /Z|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : iso + 'Z'
  const d = new Date(withZone)
  return isNaN(d.getTime()) ? null : d
}

const pad = (n) => String(n).padStart(2, '0')

export function fmtLocal(value) {
  const d = parseUtc(value)
  if (!d) return value || ''
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

export function fmtLocalShort(value) {
  const d = parseUtc(value)
  if (!d) return ''
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}
